export enum EventEmitterMessages {
  FlightUpdate = 'flightUpdate',
}
